// @ts-check
// フロントで変換する通貨
export const convertDisplayCurrencies = {
    MATIC: 'POL-MATIC',
    RNDR: 'RENDER-RNDR',
    KLAY: 'KAIA-KLAY',
    FTM: 'S-FTM',
};
